import React, { useEffect } from 'react';
import {
  BrowserRouter as Router
} from "react-router-dom";
import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline';
import TakisLayout from './components/TakisLayout';
import { theme } from './App.styles';
import AOS from 'aos';
import 'aos/dist/aos.css';

import {
  QueryClient,
  QueryClientProvider,
} from 'react-query'

function App() {
  const queryClient = new QueryClient()

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <QueryClientProvider client={queryClient}>
        <Router>
          <TakisLayout/>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
